// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import SearchAddressForm from '../../common/SearchAddressForm';

export default class ShowFormView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.setting-user-form');
    this.searchAddress = new SearchAddressForm('.setting-info-form');
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
    event.preventDefault();
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.target)
      .parent()
      .prevAll('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('.row')
      .hide();
    event.preventDefault();
  }
}
